import AbstractApiCommand from './AbstractApiCommand';
import ApiReceiver from './ApiReceiver';

class GetCommand<T> extends AbstractApiCommand<T> {
  private readonly path: string;

  constructor(apiReceiver: ApiReceiver, path: string) {
    super(apiReceiver);
    this.path = path;
  }

  // AbstractApiCommand
  handleRunCommand(): Promise<T> {
    return this.apiReceiver.getData<T>(this.path);
  }
}

export default GetCommand;
